import { Injectable } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  constructor(private translate: TranslateService) {}

  setStoredLanguage() {
    const storedLang = localStorage.getItem('language');
    if (storedLang) {
      this.translate.use(storedLang);
    } else {
      const browserLang = this.translate.getBrowserLang();
      const defaultLang = browserLang?.match(/nl|de|en/) ? browserLang : 'nl';
      this.translate.use(defaultLang);
      localStorage.setItem('language', defaultLang);
    }
  }

  setLanguage(language: string) {
    this.translate.use(language);
    localStorage.setItem('language', language);
  }

  getSelectedLanguage(): string {
    return localStorage.getItem('language') ?? 'nl';
  }

  getLanguages(): string[] {
    return ['nl', 'de', 'en'];
  }

  getTitle(translationKey: string) {
    return this.translate.instant(translationKey);
  }
}
